"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Disclaimer = void 0;
var React = _interopRequireWildcard(require("react"));
var _Banner = require("../Banner");
var _Icon = require("../Icon");
var _DisclaimerModule = _interopRequireDefault(require("./Disclaimer.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Disclaimer = exports.Disclaimer = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    leftIconName = 'info-circle',
    leftIconType = _Icon.ICON_TYPE.regular,
    ...restProps
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Banner.Banner, {
    ref: ref,
    ...restProps,
    leftIconName: leftIconName,
    leftIconType: leftIconType,
    classNames: {
      ...classNames,
      wrapper: _DisclaimerModule.default.disclaimerWrapper,
      icon: _DisclaimerModule.default.iconWrapper
    }
  });
});